import { Button } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface CanvasComponentProps {
//   value?: string;
//   onChange?: (value: string) => void;
  updateSignatureStatus : (value: boolean, dataUrl: string) => void;
}

const CanvasComponent: React.FC<CanvasComponentProps> = ({
    updateSignatureStatus
}) => {
    const { t } = useTranslation('task');
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const isDrawingRef = useRef(false);
  const [isDrawing, setIsDrawing] = useState(false);
  const [ctx, setCtx] = useState<CanvasRenderingContext2D | null>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) {
      const context = canvas.getContext('2d');
      if (context) {
        context.lineWidth = 2;
        context.lineCap = 'round';
        setCtx(context);
      }
    }
  }, []);

  const getCanvasCoordinates = (event: MouseEvent | TouchEvent) => {
    const canvas = canvasRef.current;
    if (!canvas) {
      return { x: 0, y: 0 };
    }

    const rect = canvas.getBoundingClientRect();

    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;

    let clientX = 0,
      clientY = 0;

    if ('touches' in event) {
      if (event.touches.length > 0) {
        clientX = event.touches[0].clientX;
        clientY = event.touches[0].clientY;
      }
    } else {
      clientX = event.clientX;
      clientY = event.clientY;
    }

    return {
      x: (clientX - rect.left) * scaleX,
      y: (clientY - rect.top) * scaleY,
    };
  };

  const getDataUrl = () => {
    let dataUrl = '';
    if (canvasRef.current) {
      dataUrl = canvasRef.current.toDataURL();
    }
    return dataUrl;
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !ctx) return;

    const handleTouchStart = (e: TouchEvent) => {
      if (e.touches.length === 1) {
        if (e.cancelable) {
          e.preventDefault();
        }
        const coordinates = getCanvasCoordinates(e);
        ctx.beginPath();
        ctx.moveTo(coordinates.x, coordinates.y);
        isDrawingRef.current = true;
        setIsDrawing(true);
      } else {
        isDrawingRef.current = false;
        setIsDrawing(false);
      }
    };

    const handleTouchMove = (e: TouchEvent) => {
      if (e.touches.length === 1 && isDrawingRef.current) {
        if (e.cancelable) {
          e.preventDefault();
        }
        const coordinates = getCanvasCoordinates(e);
        ctx.lineTo(coordinates.x, coordinates.y);
        ctx.stroke();
      } else if (e.touches.length > 1) {
        isDrawingRef.current = false;
        setIsDrawing(false);
      }
    };

    const handleTouchEnd = (e: TouchEvent) => {
      if (isDrawingRef.current) {
        isDrawingRef.current = false;
        setIsDrawing(false);
        if (e.touches.length === 0) {
          const dataUrl = getDataUrl();
          updateSignatureStatus(true, dataUrl);
        }
      }
    };

    canvas.addEventListener('touchstart', handleTouchStart, { passive: false });
    canvas.addEventListener('touchmove', handleTouchMove, { passive: false });
    canvas.addEventListener('touchend', handleTouchEnd);
    canvas.addEventListener('touchcancel', handleTouchEnd);

    return () => {
      canvas.removeEventListener('touchstart', handleTouchStart);
      canvas.removeEventListener('touchmove', handleTouchMove);
      canvas.removeEventListener('touchend', handleTouchEnd);
      canvas.removeEventListener('touchcancel', handleTouchEnd);
    };
  }, [ctx, updateSignatureStatus]);

  const handleMouseDown = (e: React.MouseEvent<HTMLCanvasElement>) => {
    if (!ctx) {
      return;
    }
    const { x, y } = getCanvasCoordinates(e.nativeEvent);
    ctx.beginPath();
    ctx.moveTo(x, y);
    isDrawingRef.current = true;
    setIsDrawing(true);
  };

  const handleMouseMove = (e: React.MouseEvent<HTMLCanvasElement>) => {
    if (!ctx || !isDrawingRef.current) {
      return;
    }
    const { x, y } = getCanvasCoordinates(e.nativeEvent);
    ctx.lineTo(x, y);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  const handleMouseUp = () => {
    if (isDrawingRef.current) {
      isDrawingRef.current = false;
      setIsDrawing(false);
      const dataUrl = getDataUrl();
      updateSignatureStatus(true, dataUrl);
    }
  };

  const handleMouseLeave = () => {
    isDrawingRef.current = false;
    setIsDrawing(false);
  };

  const clearCanvas = () => {
    const canvas = canvasRef.current;
    if (canvas && ctx) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      isDrawingRef.current = false;
      setIsDrawing(false);
      updateSignatureStatus(false, '');
    }
  };

  return (
    <div>
      <canvas
        ref={canvasRef}
        width={875}
        height={200}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseLeave}
        style={{ touchAction: 'manipulation' }}
        className="h-64 w-full rounded-md border border-solid border-gray-200"
      />
      <Button onClick={clearCanvas} className="mt-4 rounded-2xl">
        {t('clear')}
      </Button>
    </div>
  );
};

export default CanvasComponent;

// ---------------------------------------------------------------------------------------------------
/* import { Button } from "antd";
import { useEffect, useRef } from "react";

interface CanvasComponentProps {
    value?: string;
    onChange?: (value: string) => void;
}

const CanvasComponent: React.FC<CanvasComponentProps> = ({value, onChange}) => {
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    const isDrawing = useRef(false);
    const lastPoint = useRef<{x: number; y: number} | null > (null);
 */
/*  useEffect(() => {
        if(value && canvasRef.current){
            const context = canvasRef.current.getContext('2d');
            const img = new Image();
            img.onload = () => {
                context?.clearRect(0,0, canvasRef.current!.width, canvasRef.current!.height);
                context?.drawImage(img, 0, 0)
            }
            img.src = value;
        }
    }, [value]); */

/* const getCanvasContext = () => {
        return canvasRef.current?.getContext('2d');
    }

    const getCoordinates = (e:React.MouseEvent | React.TouchEvent): {x: number; y: number} => {
        const canvas = canvasRef.current!;
        const rect = canvas.getBoundingClientRect();
        const clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
        const clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
        return {
            x: clientX -rect.left,
            y: clientY - rect.top
        }
    }
    
    const draw = (e:React.MouseEvent | React.TouchEvent) => { */

/* if(!isDrawing.current || !canvasRef.current){
            return;
        }

        const canvas = canvasRef.current;
        const context = canvasRef.current?.getContext('2d');
        if(!context){
            return;
        }

        const rect = canvas.getBoundingClientRect();
        const clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
        const clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;

        const x = clientX - rect.left;
        const y = clientY - rect.top;

        context.lineWidth = 2;
        context.lineCap = 'round';
        context.strokeStyle = '#000';

        context.lineTo(x,y);
        context.stroke();
        context.beginPath();
        context.moveTo(x,y); */

/* 
        if(!isDrawing.current || !canvasRef.current || !lastPoint.current){
            return;
        }

        // const canvas = canvasRef.current;
        const context = getCanvasContext();
        if(!context){
            return;
        }

        const current = getCoordinates(e);
        context.beginPath();
        context.moveTo(lastPoint.current.x, lastPoint.current.y);
        context.lineTo(current.x, current.y);
        context.strokeStyle = '#000';
        context.lineWidth = 2;
        context.lineCap = 'round';
        context.stroke();
        lastPoint.current = current;


    }

    const startDrawing = (e:React.MouseEvent | React.TouchEvent) => {
        isDrawing.current = true;
        // draw(e);
        lastPoint.current = getCoordinates(e);
    }

    const endDrawing = () => {
        isDrawing.current = false;
        lastPoint.current = null;
        
        if(canvasRef.current){
            const dataUrl = canvasRef.current.toDataURL();
            onChange?.(dataUrl);
        }
    }

    const handleClear = () => {
        const canvas = canvasRef.current;

        if(canvas){
            const context = canvas.getContext('2d');
            context?.clearRect(0,0, canvas.width, canvas.height);
            onChange?.('');
        }
    }

    return (
        <div>
            <canvas 
            ref={canvasRef}
            // width={875}
            // height={200}
            onMouseDown={startDrawing}
            onMouseMove={draw}
            onMouseUp={endDrawing}
            onMouseLeave={endDrawing}
            onTouchStart={startDrawing}
            onTouchMove={draw}
            onTouchEnd={endDrawing}
            className="border border-solid border-gray-200 rounded-md w-full h-64"/>
            <Button onClick={handleClear} className="mt-8">Clear</Button>
            
        </div>
    )
}

export default CanvasComponent; */
